import "./credit.css";

const Credit = () => (
  <div className="credit">
    <span>kelvin kamau</span> | become the standard measure
  </div>
);

export default Credit;
